import React, { useReducer } from 'react';
import { View, TouchableOpacity, StyleSheet, ScrollView } from 'react-native';
import { Color, CommonProperties, CommonStyles } from '../../../styles';
import { scale } from '../../../utils/scale.utils';
import BaseText from '../../BaseText';
import Button from '../../Button';
import Icon from '../../Icon';
import Modal from '../../Modal';
import UploadWidget from '../../TripEvents/UploadWidget';

const defaultState = {
  eventImage: null,
  sponsorImage: null,
  venueImage: null,
};

const EventUploadModal = ({ initialState, visible, onClose, onUpdate }) => {
  const [state, dispatch] = useReducer(
    (state, action) => {
      if (action.type) {
        return {
          ...state,
          [action.type]: action.value,
        };
      }
    },
    initialState
      ? {
          eventImage: initialState.eventImage,
          sponsorImage: initialState.sponsorImage,
          venueImage: initialState.venueImage,
        }
      : defaultState
  );

  const onSubmit = () => {
    onUpdate(state);
  };

  return (
    <Modal visible={visible} transparent>
      <View style={stylesModal.wrap}>
        <View style={stylesModal.scroll}>
          <ScrollView>
            <View style={stylesModal.innerWrap}>
              <TouchableOpacity onPress={onClose} style={stylesModal.close}>
                <Icon name="cancel" style={stylesModal.iconClose} />
              </TouchableOpacity>
              <BaseText style={stylesModal.title}>Upload Images</BaseText>
              <UploadWidget state={state} onUpdate={dispatch} />
              <Button
                label="Add Images "
                style={stylesModal.submit}
                labelStyle={CommonStyles.h2}
                onPress={onSubmit}
              />
            </View>
          </ScrollView>
        </View>
      </View>
    </Modal>
  );
};

const stylesModal = StyleSheet.create({
  wrap: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,.5)',
    ...CommonProperties.p3,
    ...CommonProperties.centerAlignment,
  },
  scroll: {
    width: '100%',
  },
  innerWrap: {
    backgroundColor: 'white',
    ...CommonProperties.p5,
    ...CommonProperties.borderRadius2,
    alignItems: 'center',
  },
  title: {
    textAlign: 'center',
    ...CommonProperties.h1,
    ...CommonProperties.mb3,
  },
  close: {
    position: 'absolute',
    top: scale(14),
    right: scale(12),
  },
  iconClose: {
    color: Color.primary,
    fontSize: 24,
  },
  submit: {
    maxWidth: scale(240),
    width: '100%',
    ...CommonProperties.mt5,
    ...CommonProperties.borderRadius4,
    ...CommonProperties.py3,
  },
});

export default EventUploadModal;
